import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { DisplayOrder } from '../DisplayOrder';

interface Props {
  isOnTop: boolean;
}

export const Wrapper = styled(Box)<Props>`
  ${({ isOnTop }) => {
    if (isOnTop) {
      return `
        z-index: ${DisplayOrder.Header};
        position: absolute;
        top: 0;
      `;
    }
  }}
  margin-top: 12px;
  margin-left: 14px;
`;
